import { render } from "./sbImgUrl.vue?vue&type=template&id=11d64bc0&scoped=true"
import script from "./sbImgUrl.vue?vue&type=script&lang=js"
export * from "./sbImgUrl.vue?vue&type=script&lang=js"

import "./sbImgUrl.vue?vue&type=style&index=0&id=11d64bc0&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d64bc0"]])

export default __exports__